/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_ApnsInputs */

const en_svchip_apns = /** @type {(inputs: Svchip_ApnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APNs`)
};

const ar_svchip_apns = /** @type {(inputs: Svchip_ApnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إشعارات أبل`)
};

const bn_svchip_apns = /** @type {(inputs: Svchip_ApnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APNs`)
};

const de_svchip_apns = /** @type {(inputs: Svchip_ApnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APNs`)
};

const es_svchip_apns = /** @type {(inputs: Svchip_ApnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APN`)
};

const fr_svchip_apns = /** @type {(inputs: Svchip_ApnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APN`)
};

const pt_svchip_apns = /** @type {(inputs: Svchip_ApnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APNs`)
};

const zh_svchip_apns = /** @type {(inputs: Svchip_ApnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APN`)
};

const tr_svchip_apns = /** @type {(inputs: Svchip_ApnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APN'ler`)
};

const ru_svchip_apns = /** @type {(inputs: Svchip_ApnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APN`)
};

const pl_svchip_apns = /** @type {(inputs: Svchip_ApnsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APN`)
};

/**
* | output |
* | --- |
* | "APNs" |
*
* @param {Svchip_ApnsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_apns = /** @type {((inputs?: Svchip_ApnsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_ApnsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_apns(inputs)
	if (locale === "bn") return bn_svchip_apns(inputs)
	if (locale === "de") return de_svchip_apns(inputs)
	if (locale === "es") return es_svchip_apns(inputs)
	if (locale === "fr") return fr_svchip_apns(inputs)
	if (locale === "pt") return pt_svchip_apns(inputs)
	if (locale === "zh") return zh_svchip_apns(inputs)
	if (locale === "tr") return tr_svchip_apns(inputs)
	if (locale === "ru") return ru_svchip_apns(inputs)
	if (locale === "pl") return pl_svchip_apns(inputs)
	return en_svchip_apns(inputs)
});